import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoTwitter } from "react-icons/io";
import { GiAbstract007 } from "react-icons/gi";

const Footer = () => {
  return (
    <footer>
      <div className="footer__container">
        <a href="#" className="footer__logo">
          <GiAbstract007 className="footer__logo-icon" />
          Abrar Hoque
        </a>

        <ul className="permalinks">
          <li>
            <a href="#">Home</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#experience">Skillsets</a>
          </li>
          <li>
            <a href="#timeline">TimeLine</a>
          </li>
          <li>
            <a href="#services">Experiences</a>
          </li>
          <li>
            <a href="#portfolio">Portfolio</a>
          </li>
          <li>
            <a href="#testimonials">Testimonials</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>

        <div className="footer__socials">
          <a href="https://twitter.com/zone_astronomy" aria-label="Twitter">
            <IoLogoTwitter />
          </a>
          <a href="https://github.com/ahoque32" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{verticalAlign: 'middle'}}>
              <path d="M12 0.297C5.373 0.297 0 5.67 0 12.297c0 5.289 3.438 9.773 8.207 11.387.6.111.793-.261.793-.577 0-.285-.011-1.232-.017-2.235-3.338.726-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.418-1.304.762-1.604-2.665-.304-5.466-1.332-5.466-5.931 0-1.31.469-2.381 1.236-3.221-.124-.303-.535-1.523.117-3.176 0 0 1.008-.323 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.553 3.297-1.23 3.297-1.23.653 1.653.242 2.873.119 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.804 5.625-5.475 5.921.43.371.823 1.102.823 2.222 0 1.606-.014 2.899-.014 3.293 0 .319.192.694.801.576C20.565 22.066 24 17.583 24 12.297c0-6.627-5.373-12-12-12z"/>
            </svg>
          </a>
        </div>

        <div className="footer__copyright">
          <small>&copy; {new Date().getFullYear()} Abrar Hoque. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
